import {AbstractCommand} from "./abstract.command";
import {CommandName} from "./command-name.enum";

/** The payload the backend reads: the board's uid and its new title. */
export interface RenameLinkviewPayload {
    readonly uid: string;
    readonly title: string;
}

/**
 * Renames a Linkboard page. The envelope carries `mainEntityClass: 'linkview'`
 * and the board's uid as `mainEntityUid`, exactly like `CreateLinkviewCommand`;
 * the payload repeats the uid next to the new title, which is what the backend
 * handler reads.
 *
 * Needs its own transformer (`rename-linkview-command-to-dto.transformer.ts`) —
 * see the note there for what happens without one.
 */
export class RenameLinkviewCommand extends AbstractCommand<RenameLinkviewPayload> {

    public name = CommandName.RENAME_LINKVIEW;

    public tags: string[] = [`entity`, `rename`, `linkview`];

    constructor(payload: RenameLinkviewPayload) {
        super('linkview', payload.uid, payload);
    }
}
